import { userPermissions } from '../../legacy/lib/config/user-permissions';
import { httpClient } from '../../lib/http-client';

export type TimeZone = {
  timezone: string;
};

export type TimeZoneItem = {
  id: string;
};

const client = httpClient.defaultClient;

export const TimezoneAPI = {
  fetchList() {
    return client.get<{ items: TimeZoneItem[] }>('/app/api/dict/timezones');
  },
  /**
   * Получение часового пояса организации
   */
  fetchOrganizationTimezone() {
    return client.get<TimeZone>(`/app/api/my/${userPermissions.nick}/settings/timezone`);
  },
  /**
   * Изменение часового пояса организации
   */
  updateOrganizationTimezone(payload: TimeZone) {
    return client.post<TimeZone>(`/app/api/my/${userPermissions.nick}/settings/timezone`, {
      json: payload
    });
  }
};
